import { Button, Space, Table, TableColumnsType } from "antd";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { PermissionCustomer } from "../../../../permissions/PermissionCustomer";
import customerStore from "../../../../stores/customerStore";
import ContentBox from "../../../molecules/ContentBox";
import Permission from "../../../molecules/Permission";
import DrawerAddress from "../DrawerAddress";
import ActionButton from "../../../atoms/ButtonComponent";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import ModalComponent from "../../../organisms/ModalComponent";

interface DataType {
  uuid: any;
  zipCode: string;
  street: string;
  block: string;
  number: string;
  state: string;
  city: string;
  key: React.Key;
}

const ListAddress: React.FC = observer(() => {
  const { loading, addressList } = customerStore;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
  const [itemSelectedDelete, setItemSelectedDelete] = useState<any>();

  const columns: TableColumnsType<DataType> = [
    {
      title: "CEP",
      dataIndex: "zipCode",
      key: "zipCode",
    },
    {
      title: "Rua",
      dataIndex: "street",
      key: "street",
    },
    {
      title: "Bairro",
      dataIndex: "block",
      key: "block",
    },
    {
      title: "Número",
      dataIndex: "number",
      key: "number",
    },
    {
      title: "Estado",
      dataIndex: "state",
      key: "state",
    },
    {
      title: "Cidade",
      dataIndex: "city",
      key: "city",
    },
    // {
    //   title: 'Editar',
    //   dataIndex: 'edit',
    //   key: 'edit',
    //   align: 'center',
    //   width: 40,
    //   render: (text, record) => (
    //     <Space className="cursor-pointer" onClick={() => showDeleteModal(record)}>
    //       <div><DeleteOutlined /></div>
    //     </Space>
    //   ),
    // },
  ];

  const showDeleteModal = (record: any) => {
    setItemSelectedDelete(record);
    setIsModalDeleteOpen(true);
  };

  const handleDeleteItem = async () => {
    await customerStore.deleteAddress(itemSelectedDelete);
  };

  return (
    <>
      <Permission permissionKeys={[PermissionCustomer.POST, PermissionCustomer.PUT, PermissionCustomer.GET_UUID]}>
        <ContentBox
          className="mb-4 p-6"
          title="Endereços"
          description="Endereços do Cliente"
          borderCustom='rounded-b-lg'
        >
          <Table
            className="table-custom"
            columns={columns}
            dataSource={
              addressList &&
              addressList.map((item: any, index: number) => ({
                ...item,
                key: item.uuid || index,
              }))
            }
            loading={loading}
            size="middle"
            bordered={false}
          />
        </ContentBox>

        <DrawerAddress setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />

        <ModalComponent
          title="Aviso"
          content={<p>Você está prestes o endereço <b></b></p>}
          isModalOpen={isModalDeleteOpen}
          handleOk={handleDeleteItem}
          handleCancel={() => setIsModalDeleteOpen(false)}
        />
      </Permission>
    </>
  );
});

export default ListAddress;
